import { masks, onlyNumbers } from 'util/mask'

import { MaskedField, MaskedFieldProps } from '../core/MaskedField'

export function DeclaracaoObitoField(props: MaskedFieldProps) {
  return <MaskedField mask={masks.numeroDeclaracaoObito} placeholder='00000000-0' parse={onlyNumbers} {...props} />
}
